import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useShortcutTarget } from '../contexts/ShortcutsContext';
import { useNav } from '../contexts/NavContext';
import { MAIN_TAB_META, autoColor, metaLabel } from '../constants/shortcutTargets';

/**
 * Makes a main tab's sub-tab pinnable: the pin captures `{ [ctxKey]: value }`
 * and a shortcut carrying that key re-opens the same sub-tab.
 * `labels` maps sub-tab value -> translation key.
 */
const useSubTabShortcut = ({ tab, ctxKey, value, setValue, labels, allowed, icon, perms }) => {
  const { t } = useTranslation();
  const { navContext } = useNav();
  const wanted = navContext?.[ctxKey];

  useEffect(() => {
    // Ignore stale shortcuts to sub-tabs that are gone or hidden for this user.
    if (wanted && labels?.[wanted] && (!allowed || allowed.includes(wanted))) setValue(wanted);
    // Only react to a new navigation, not to the user switching sub-tabs.
  }, [navContext]);

  const main = MAIN_TAB_META[tab] || {};
  const label = labels?.[value] ? t(labels[value]) : '';
  useShortcutTarget(value && label ? {
    tab,
    context: { [ctxKey]: value },
    label,
    subtitle: metaLabel(main, t),
    icon: icon || main.icon || 'star',
    color: autoColor(`${tab}-${value}`),
    perms: (typeof perms === 'function' ? perms(value) : perms) || main.perms || [],
  } : null, 1);
};

export default useSubTabShortcut;
